import { render, staticRenderFns } from "./MyPortfolio.vue?vue&type=template&id=6ace0485&"
import script from "./MyPortfolio.vue?vue&type=script&lang=js&"
export * from "./MyPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports